import type { ListProjectsParams } from './projects';

export const queryKeys = {
  projectList: (params: ListProjectsParams) => ['projects', 'list', params] as const,
  projectDetail: (id: string) => ['projects', 'detail', id] as const,
  simulationVideo: (id: string) => ['projects', 'video', id] as const,
  simulationMesh: (id: string) => ['projects', 'mesh', id] as const,
  modelPreview: (modelId: string) => ['modelFiles', 'preview', modelId] as const,
};
